import React from 'react';
import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';
import ChevronDown from 'design-system/src/assets/icons/chevronDown.svg?react';
import {
  PopoverMenu,
  PopoverMenuButton,
  PopoverMenuSection,
  PopoverMenuItems,
  PopoverMenuItem,
  PopoverMenuItemButton,
} from 'design-system/src/components/PopoverMenu/PopoverMenu';
import { baseButtonStyles, secondaryButtonStyles, smallButtonStyles } from 'design-system/src/components/Button/Button';
import { createTrackingProps } from 'shared-utils/analytics';

const StyledPopoverMenuButton = styled(PopoverMenuButton)`
  ${baseButtonStyles}
  ${secondaryButtonStyles}
  ${smallButtonStyles}
`;

export type ClosePrescriptionPopoverMenuProps = {
  /**
   * Callback when "Move prescription to Completed" is clicked
   */
  onCompleteClick: () => void;
  /**
   * Callback when "Cancel processing with Tandem" is clicked
   */
  onCancelClick: () => void;
};

/**
 * Popover menu component for closing a prescription (completing or canceling)
 */
export const ClosePrescriptionPopoverMenu = ({ onCompleteClick, onCancelClick }: ClosePrescriptionPopoverMenuProps) => {
  return (
    <PopoverMenu {...createTrackingProps({ unmask: true })}>
      <StyledPopoverMenuButton
        {...createTrackingProps({
          elementName: 'Prescription Page: Close prescription Popover Menu Button',
        })}
      >
        <Typography styledAs="bodySmallSpaceGrotesk" weight={500} className="whitespace-nowrap">
          Close prescription
        </Typography>
        <ChevronDown aria-hidden="true" width="10px" height="10px" />
      </StyledPopoverMenuButton>
      <PopoverMenuItems>
        <PopoverMenuSection>
          <PopoverMenuItem>
            {(itemProps) => (
              <PopoverMenuItemButton
                {...itemProps}
                onClick={onCompleteClick}
                {...createTrackingProps({
                  elementName: 'Prescription Page: Move prescription to Completed Button',
                })}
              >
                Move prescription to Completed
              </PopoverMenuItemButton>
            )}
          </PopoverMenuItem>
          <PopoverMenuItem>
            {(itemProps) => (
              <PopoverMenuItemButton
                {...itemProps}
                onClick={onCancelClick}
                {...createTrackingProps({
                  elementName: 'Prescription Page: Cancel processing with Tandem Button',
                })}
              >
                Cancel processing with Tandem
              </PopoverMenuItemButton>
            )}
          </PopoverMenuItem>
        </PopoverMenuSection>
      </PopoverMenuItems>
    </PopoverMenu>
  );
};

export default ClosePrescriptionPopoverMenu;
